import {
	getStormData,
	showPurchaseMap,
	setCurrentMap,
} from './';
import moment from 'moment';
import {
	ADD_FOUND_MAP,
	ADD_FOUND_MAPS,
	REMOVE_FOUND_MAP,
	ADD_DOWNLOADED_MAP,
	REMOVE_DOWNLOADED_MAP,
	SHOW_DOWNLOADED_MAP,
	HIDE_DOWNLOADED_MAP,
	SHOW_DOWNLOADED_MAPS,
	HIDE_DOWNLOADED_MAPS,
	SHOW_FOUND_MAPS,
	HIDE_FOUND_MAPS,
	SHOW_DOWNLOADED_MAP_INFO,
	HIDE_DOWNLOADED_MAP_INFO,
	TOGGLE_SHOW_DOWNLOADED_MAP_MARKERS,
	CLEAR_DOWNLOADED_MAPS
} from 'constants';
import * as ActionTypes from 'constants';
import { callApi } from 'api';
import { notify } from 'actions';

export const addFoundMap = (map) => ({
	type : ADD_FOUND_MAP,
	payload : {map}
});

export const addFoundMaps = (maps) => ({
	type : ADD_FOUND_MAPS,
	payload : {maps}
})

export const removeFoundMap = (id) => ({
	type : REMOVE_FOUND_MAP,
	payload : { id }
});

export const addDownloadedMap = (map) => ({
	type : ADD_DOWNLOADED_MAP,
	payload : {map}
});

export const removeDownloadedMap = (id) => ({
	type : REMOVE_DOWNLOADED_MAP,
	payload : { id }
});

export const showDownloadedMap = (id) => ({
	type : SHOW_DOWNLOADED_MAP,
	payload : { id }
});

export const hideDownloadedMap = (id) => ({
	type : HIDE_DOWNLOADED_MAP,
	payload : { id }
});

export const toggleShowDownloadedMapMarkers = (map_id, markers_visible) => ({
	type: TOGGLE_SHOW_DOWNLOADED_MAP_MARKERS, payload: { map_id, markers_visible }
});

export const showDownloadedMaps = f => ({
	type : SHOW_DOWNLOADED_MAPS
})
export const hideDownloadedMaps = f => ({
	type : HIDE_DOWNLOADED_MAPS
})
export const showFoundMaps = f => ({
	type : SHOW_FOUND_MAPS
})
export const hideFoundMaps = f => ({
	type : HIDE_FOUND_MAPS
})
export const showDownloadedMapInfo = id => ({
	type : SHOW_DOWNLOADED_MAP_INFO,
	payload : { id }
});
export const hideDownloadedMapInfo = id => ({
	type : HIDE_DOWNLOADED_MAP_INFO,
	payload : { id }
});

export const favoriteMap = id => ({
	type: ActionTypes.FAVORITE_MAP,
	payload : { id },
});

export const clearDownloadedMaps = () => ({ type: CLEAR_DOWNLOADED_MAPS });

export const findMaps = (query, cb) => {
	return dispatch => {

		if(typeof query.coordinates !== 'undefined')
			query.coordinates = JSON.stringify(query.coordinates);

		if(typeof query.startDate !== undefined && typeof query.endDate !== undefined) {
			query.startDate = JSON.stringify(query.startDate)
			query.endDate = JSON.stringify(query.endDate)
		}

		callApi('POST', '/maps/search', query, 'application/json')
			.then(maps => {
				dispatch(addFoundMaps(maps));
				if(typeof cb === 'function')
					cb(maps);
			})
			.catch(error => {
				dispatch(notify(error));
			})
	}
}


export const downloadMap = (id, callback) => {
	return dispatch => {
    dispatch({
      type : ActionTypes.FETCH_MAP,
      payload : { id }
    });

		callApi('GET', `/map/${ id }`, null)
			.then(map => {
				if(map.status == 403) {
          dispatch(showPurchaseMap(map.map));
        }
        else {
          dispatch(setCurrentMap(map));
          dispatch(addDownloadedMap(map));
          dispatch({
            type : ActionTypes.FETCH_MAP_SUCCESS,
            payload : { id }
          });

          var date = moment(map.properties.storm_date.slice(0,10), "YYYY-MM-DD").format('MM/DD/YYYY');

          dispatch(getStormData(date));
          if(callback)
            callback(null, map);
        }
			})
			.catch(error => {
				dispatch({
          type : ActionTypes.FETCH_MAP_FAILURE,
          payload : { id }
        })
				if(error.status == 403) {
					dispatch(showPurchaseMap(error.map));
				}
				else
					dispatch(notify(error))
				if(callback)
					callback(error,null);
			})
	}
}



// WEBPACK FOOTER //
// ./src/common/actions/map_search.js